import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Regular from "./OpenSans-Regular.woff2";

export const OpenSansRegularFontFaces: ExcalidrawFontFaceDescriptor[] = [
  { uri: Regular },
];
